<template>
    <el-dialog v-model="dialogShow" width="640px" title="个人信息" center @close="closeEvent" append-to-body>
        <!-- <template #header>
                                            <div style="display:flex;align-items:center;justify-content: center;">
                                                <span>个人信息</span>
                                                <el-button style="margin-left:10px;" v-if="userInfo.isFromB=='00'" color="#ef8b25" plain size="small" @click="studentShow=true">信息维护</el-button>
                                            </div>
                                        </template> -->
        <div class="login-container">
            <div v-if="userInfo.isFromB=='00'">
                <el-button color="#ef8b25" plain size="small" @click="studentShow=true">信息维护</el-button>
            </div>
            <div class="login-form">
                <el-descriptions class="margin-top" :column="2" border label-width="120px">
                    <el-descriptions-item label="姓名">
                        {{userInfo.userName}}
                    </el-descriptions-item>
                    <el-descriptions-item label="学籍号">
                        {{userInfo.studentNo}}
                    </el-descriptions-item>
                    <el-descriptions-item label="地区">
                        {{cityInfo}}
                    </el-descriptions-item>
                    <el-descriptions-item label="手机号">
                        {{userInfo.userPhone}}
                    </el-descriptions-item>
                    <el-descriptions-item label="账号ID">
                        {{userInfo.userId}}
                    </el-descriptions-item>
                </el-descriptions>
            </div>
        </div>

        <student-dialog :popupShow="studentShow" isPerson v-if="studentShow" @close="studentClose"></student-dialog>
    </el-dialog>
</template>
<script lang="ts" setup>
import studentDialog from "./studentDialog.vue"
import { ref, reactive, onMounted, computed, defineProps, defineEmits } from 'vue';
import { useStore } from "vuex"
const store = useStore();
import { useRouter } from 'vue-router';
const router = useRouter();
const props = defineProps({
    popupShow: {
        type: Boolean,
        default: false
    }
})
const dialogShow = ref(props.popupShow)
const userInfo = ref(store.state.userInfo)
const studentShow = ref(false)
const emitList = defineEmits(['close'])
const cityInfo = computed(() => {
    const { provinceName, cityName, areaName } = userInfo.value
    let str = ''
    if (provinceName) {
        str += provinceName
    }
    if (cityName) {
        str += cityName
    }
    if (areaName) {
        str += areaName
    }
    return str
})

const isBCustom = computed(() => {
    return userInfo.value.schoolNmae ? true : false
})

function closeEvent() {
    emitList('close')
}

function studentClose() {
    router.go(0)
}

</script>
<style lang="scss" scoped>
@import "@/style/variable.scss";
.login-container {
    padding: 10px;
    .login-title {
        font-size: 20px;
        font-weight: bold;
        color: $base-text-color;
        margin-bottom: 10px;
    }
    .login-tabs {
        display: flex;
        font-weight: bold;
        color: $base-text-color;
        &>div {
            width: 100px;
            text-align: center;
            line-height: 24px;
        }
        .active {
            color: $base-color;
            border-bottom: 2px solid $base-color;
        }
    }
    .login-form {
        margin: 20px 0 0;
    }
}

.bordered-table {
    border-collapse: collapse;
    border-radius: 10px;
    td {
        border: 1px solid #ccc;
    }
    .table-label {
        width: 100px;
        padding: 10px;
    }
    .table-value {
        padding: 10px;
        width: 260px;
    }
}
</style>

